import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
  ApiBlobGetRequest,
} from '../../api';
import { showNotif } from '../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Pengeluaran',
    title_pemasukan: 'Pemasukan',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Pengeluaran',
        href: '/adm/pengeluaran',
        active: true,
      },
    ],
    breadcrumb_pemasukan: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Pemasukan',
        href: '/adm/pemasukan',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    totalRows: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_materi',
    sortDesc: true,
    fields: [
      {
        key: 'no',
        label: 'No',
        thStyle: {
          width: '50px',
        },
      },
      {
        key: 'created_at',
        label: 'Tanggal',
        sortable: true,
        thStyle: {
          width: '120px',
        },
      },
      {
        key: 'code_materi',
        label: 'Kode',
        sortable: true,
        thStyle: {
          width: '120px',
        },
      },
      {
        key: 'desc_materi',
        label: 'Keterangan',
        sortable: true,
      },
      {
        key: 'url_materi',
        label: 'URL Materi',
      },
      {
        key: 'aksi',
        label: 'Aksi',
        thStyle: {
          width: '80px',
        },
      },
    ],
    detail: false,
    form: {
      cust_code: '',
      cust_company: '',
      cust_address: '',
      cust_email: '',
      cust_phone: '',
    },
    import_form: [],
    id_distributor: '',
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeMateri(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchMateri(context, params = null) {
    let result = await ApiGetRequest(`materi`, params);
    return !result.error ? result.data.object : [];
  },

  async getListMateri({ commit, state }, payload = {}) {
    commit('changeMateri', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...payload,
      start_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 0 &&
        payload.date_filter[0]
          ? moment(payload.date_filter[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 1 &&
        payload.date_filter[1]
          ? moment(payload.date_filter[1]).format('YYYY-MM-DD')
          : '',
    };

    if (payload && payload.export) {
      let result = await ApiBlobGetRequest(`materi`, params);
      commit('changeMateri', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_materi.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    } else {
      let result = await ApiGetRequest(`materi`, params);
      commit('changeMateri', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? true : false;
    }
  },

  async getDetailMateri({ commit, state }, payload = null) {
    commit('changeMateri', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`materi/${payload.id}`);
    commit('changeMateri', {
      loading: false,
      detail: result.error ? false : result.data.object,
      form: {
        ...data.form,
        ...result.data.object,
      },
    });

    return result.error ? false : true;
  },

  async createMateri({ commit, state, dispatch }) {
    commit('changeMateri', {
      loading: true,
    });

    let result = await ApiPostRequest(`materi`, state.data.form);
    commit('changeMateri', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateMateri({ commit, state, dispatch }, payload = null) {
    commit('changeMateri', {
      loading: true,
    });

    let result = await ApiPutRequest(`materi/${payload.id}`, state.data.form);

    commit('changeMateri', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteMateri({ commit, dispatch }, payload = null) {
    commit('changeMateri', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`materi/${payload.id}`);
    commit('changeMateri', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
